import React from "react"
import { ImSpinner6 } from "react-icons/im"

const Loading: React.FC = () => {
  return (
    <div className="fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center bg-slate-500 opacity-85">
      <div className="relative grid h-full grid-cols-3 grid-rows-3 place-items-center">
        <ImSpinner6 className="text-[150px]  animate-ping row-start-2 col-start-2" />
        <h2 className="col-start-2 row-start-2 p-4 text-lg text-slate-100">
          Processing
        </h2>
      </div>
    </div>
  )
}

export default Loading
